module.exports = __webpack_public_path__ + "static/media/3233.da221373.jpg";